<template>
  <div>
    <a
      class="px-3"
      v-for="(item, index) in languages"
      :key="index"
      :class="{ 'font-weight-bold text-primary': item === locale }"
      @click="languageSwitch(item)"
    >
      {{ item | languageText }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'localeSwitch',
  props: ['languages', 'languageSwitch'],
  computed: {
    locale() {
      return this.$store.getters.locale
    },
  },
}
</script>
